// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../paletteShell/paletteShell.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The BUILT-IN palette shares the tools-palette shell (paletteShell.module.css)
   for all common chrome, as the MODELS and AGENTS palettes do; only its tiles
   are its own. */

.nJRzyPtLZCzkTAC1HbAM { }
.uIAsUGPJizIhYIh3gy4a { }
.Oe6X04WB9ssypz1lanJg { }
.G7jE4raA9JsREcGscd5a { }
.C5A7dHojnN7OXT3DwJaK { }
.QtE66jaRrOwE0UuUNzS4 { }
.V2njmtZRCqUIw_lTkU7w { }
.VksjdO87ONyl85EXjLsN { }
.Lbjuaarv627tcx5Wh9nr { }
.MUe5OehbGBssoJ7L4lW0 { }
.Ha_9Fm7EC_Pz5JdVAr2a { }
.z6krZfTQB_K1pzrfYLxb { }
.qBSCh6AcWOL02X6NqtlB { }
.sYkC4bfiFx6M4GqUr8A2 { }
._9tx3Sf5lVnsGwnNfVvXQ { }

/* One group of tiles: data and flow, computation, or the views. The tracks are
   the tiles' own 45px, so a group fills the panel's width row by row instead of
   spreading two tiles across it. */
.Q_Ic6aUT_RsrDvJw2LOD {
    display: grid;
    grid-template-columns: repeat(auto-fill, 45px);
    grid-auto-rows: 45px;
}

.nVxFe_sEbu8fNpz5XyVA {
    height: 1px;
    background-color: rgba(255,255,255,0.15);
    margin: 5px 0;
}

.mSr33fiwq3gMrc9LNo2i {
    width: 45px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 10px;
    position: relative;
}

.Ex8EnPQcEP9LOMJJraYA {
    position: absolute;
    bottom: 2px;
    right: 2px;
    font-size: 7px;
    font-weight: 700;
    letter-spacing: 0.3px;
    color: #fbfcf6;
    background-color: #2a6df4;
    padding: 1px 3px;
    border-radius: 3px;
    line-height: 1;
    pointer-events: none;
}

.Vd09mpjFbhWBQ0MdPXbG {
    font-size: 1.5em;
    color: #fbfcf6;
}
`, "",{"version":3,"sources":["webpack://./src/components/menus/nodes/builtinPalette/BuiltinPalette.module.css"],"names":[],"mappings":"AAAA;;iBAEiB;;AAEjB,wBAAuE;AACvE,wBAA2E;AAC3E,wBAA6E;AAC7E,wBAAmF;AACnF,wBAAqF;AACrF,wBAAqF;AACrF,wBAAuF;AACvF,wBAAuF;AACvF,wBAA2F;AAC3F,wBAAyE;AACzE,wBAAqF;AACrF,wBAAyE;AACzE,wBAA2E;AAC3E,wBAAuF;AACvF,yBAA2E;;AAE3E;;mCAEmC;AACnC;IACI,aAAa;IACb,8CAA8C;IAC9C,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,wCAAwC;IACxC,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB","sourcesContent":["/* The BUILT-IN palette shares the tools-palette shell (paletteShell.module.css)\n   for all common chrome, as the MODELS and AGENTS palettes do; only its tiles\n   are its own. */\n\n.root { composes: root from \"../paletteShell/paletteShell.module.css\"; }\n.column { composes: column from \"../paletteShell/paletteShell.module.css\"; }\n.trigger { composes: trigger from \"../paletteShell/paletteShell.module.css\"; }\n.triggerTop { composes: triggerTop from \"../paletteShell/paletteShell.module.css\"; }\n.triggerOpen { composes: triggerOpen from \"../paletteShell/paletteShell.module.css\"; }\n.triggerIcon { composes: triggerIcon from \"../paletteShell/paletteShell.module.css\"; }\n.triggerLabel { composes: triggerLabel from \"../paletteShell/paletteShell.module.css\"; }\n.triggerCount { composes: triggerCount from \"../paletteShell/paletteShell.module.css\"; }\n.triggerChevron { composes: triggerChevron from \"../paletteShell/paletteShell.module.css\"; }\n.panel { composes: panel from \"../paletteShell/paletteShell.module.css\"; }\n.panelHeader { composes: panelHeader from \"../paletteShell/paletteShell.module.css\"; }\n.title { composes: title from \"../paletteShell/paletteShell.module.css\"; }\n.scroll { composes: scroll from \"../paletteShell/paletteShell.module.css\"; }\n.sectionEmpty { composes: sectionEmpty from \"../paletteShell/paletteShell.module.css\"; }\n.footer { composes: footer from \"../paletteShell/paletteShell.module.css\"; }\n\n/* One group of tiles: data and flow, computation, or the views. The tracks are\n   the tiles' own 45px, so a group fills the panel's width row by row instead of\n   spreading two tiles across it. */\n.containerStyle {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, 45px);\n    grid-auto-rows: 45px;\n}\n\n.divider {\n    height: 1px;\n    background-color: rgba(255,255,255,0.15);\n    margin: 5px 0;\n}\n\n.optionStyle {\n    width: 45px;\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 10px;\n    position: relative;\n}\n\n.iconBadge {\n    position: absolute;\n    bottom: 2px;\n    right: 2px;\n    font-size: 7px;\n    font-weight: 700;\n    letter-spacing: 0.3px;\n    color: #fbfcf6;\n    background-color: #2a6df4;\n    padding: 1px 3px;\n    border-radius: 3px;\n    line-height: 1;\n    pointer-events: none;\n}\n\n.iconStyle {\n    font-size: 1.5em;\n    color: #fbfcf6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `nJRzyPtLZCzkTAC1HbAM ${___CSS_LOADER_ICSS_IMPORT_0___.locals["root"]}`,
	"column": `uIAsUGPJizIhYIh3gy4a ${___CSS_LOADER_ICSS_IMPORT_0___.locals["column"]}`,
	"trigger": `Oe6X04WB9ssypz1lanJg ${___CSS_LOADER_ICSS_IMPORT_0___.locals["trigger"]}`,
	"triggerTop": `G7jE4raA9JsREcGscd5a ${___CSS_LOADER_ICSS_IMPORT_0___.locals["triggerTop"]}`,
	"triggerOpen": `C5A7dHojnN7OXT3DwJaK ${___CSS_LOADER_ICSS_IMPORT_0___.locals["triggerOpen"]}`,
	"triggerIcon": `QtE66jaRrOwE0UuUNzS4 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["triggerIcon"]}`,
	"triggerLabel": `V2njmtZRCqUIw_lTkU7w ${___CSS_LOADER_ICSS_IMPORT_0___.locals["triggerLabel"]}`,
	"triggerCount": `VksjdO87ONyl85EXjLsN ${___CSS_LOADER_ICSS_IMPORT_0___.locals["triggerCount"]}`,
	"triggerChevron": `Lbjuaarv627tcx5Wh9nr ${___CSS_LOADER_ICSS_IMPORT_0___.locals["triggerChevron"]}`,
	"panel": `MUe5OehbGBssoJ7L4lW0 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["panel"]}`,
	"panelHeader": `Ha_9Fm7EC_Pz5JdVAr2a ${___CSS_LOADER_ICSS_IMPORT_0___.locals["panelHeader"]}`,
	"title": `z6krZfTQB_K1pzrfYLxb ${___CSS_LOADER_ICSS_IMPORT_0___.locals["title"]}`,
	"scroll": `qBSCh6AcWOL02X6NqtlB ${___CSS_LOADER_ICSS_IMPORT_0___.locals["scroll"]}`,
	"sectionEmpty": `sYkC4bfiFx6M4GqUr8A2 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["sectionEmpty"]}`,
	"footer": `_9tx3Sf5lVnsGwnNfVvXQ ${___CSS_LOADER_ICSS_IMPORT_0___.locals["footer"]}`,
	"containerStyle": `Q_Ic6aUT_RsrDvJw2LOD`,
	"divider": `nVxFe_sEbu8fNpz5XyVA`,
	"optionStyle": `mSr33fiwq3gMrc9LNo2i`,
	"iconBadge": `Ex8EnPQcEP9LOMJJraYA`,
	"iconStyle": `Vd09mpjFbhWBQ0MdPXbG`
};
export default ___CSS_LOADER_EXPORT___;
